import { useState } from 'react';
import { DateRange, PickerModal } from 'mui-daterange-picker-plus';
import { InputAdornment } from '@mui/material';
import { Event } from '@mui/icons-material';
import { ptBR } from 'date-fns/locale';
import TextField from 'components/TextField';
import dayjs from 'dayjs';

function RangePicker({ value, ...props }: any ){
  const [ anchorEl, setAnchorEl ] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSubmit = (event: any) => {
    handleClose();

    if(typeof props.onChange === 'function')
      props.onChange(event);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return(
    <>
      <TextField
        onClick={handleClick}
        InputProps={{ endAdornment: <InputAdornment position='end'><Event/></InputAdornment> }}
        {...props}
        value={value ? `${dayjs(value.startDate).format('DD/MM/YYYY')} - ${dayjs(value.endDate).format('DD/MM/YYYY')}` : ''}
      />
      <PickerModal
        locale={ptBR}
        initialDateRange={{
          startDate: value ? value.startDate : null,
          endDate: value ? value.endDate : null,
        }}
        customProps={{
        onSubmit: (range: DateRange) => handleSubmit(range),
          onCloseCallback: handleClose,
        }}
        hideDefaultRanges={false}
        hideOutsideMonthDays={true}
        definedRanges={[
          {
            label: 'Hoje',
            startDate: dayjs().toDate(),
            endDate: dayjs().toDate()
          },
          {
            label: 'Essa Semana',
            startDate: dayjs().startOf('w').toDate(),
            endDate: dayjs().endOf('w').toDate()
          },
          {
            label: 'Últimos 7 dias',
            startDate: dayjs().subtract(7, 'day').toDate(),
            endDate: dayjs().toDate()
          },
          {
            label: 'Esse Mês',
            startDate: dayjs().startOf('M').toDate(),
            endDate: dayjs().endOf('M').toDate()
          },
          {
            label: 'Últimos 30 dias',
            startDate: dayjs().subtract(30, 'day').toDate(),
            endDate: dayjs().toDate()
          },
          {
            label: 'Esse Ano',
            startDate: dayjs().startOf('y').toDate(),
            endDate: dayjs().toDate()
          }
        ]}
        modalProps={{
          open,
          anchorEl,
          onClose: handleClose,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
        labels={{
          predefinedRanges: 'Seleção rápida',
          footer: {
            startDate: 'Data Inicial',
            endDate: 'Data Final'
          },
          actions: {
            apply: 'Aplicar',
            cancel: 'Cancelar'
          }
        }}
      />
    </>
  )
};
export default RangePicker;